import { useState } from "react";
import { Box, Typography } from "@mui/material";

// components
import { TextFieldNum } from "../../ui/text-field-num";
import { MIN_CONSTRUCTION_HEIGHT } from "../../../constants/global.constants";
import { TEXT } from "../../../constants/text";
import { useUserContext } from "../../../services/context/user-context";

// svg
import { ReactComponent as IconInformation } from "../../../assets/svg/information.svg";


export const RegulationsTab = ({
  propertyData,
  updatePropertyData,
  setRegulationsError,
  maxInnerBuildHeight
}) => {
  const { viewOnly } = useUserContext();
  const [errorMinBorder, setErrorMinBorder] = useState(null);
  const [errorMaxConstrHeight, setErrorMaxConstrHeight] = useState(null);
  const [errorBuildingDensity, setErrorBuildingDensity] = useState(null);

  const maxBorder = propertyData.maxBorder
    ? propertyData.maxBorder.toFixed(2)
    : null;

  const setMinBorder = (value, error) => {
    updatePropertyData("minBorderDistance", value);
    setErrorMinBorder(error);
    setRegulationsError(error || errorMaxConstrHeight || errorBuildingDensity);
  };
  const setMaxConstrHeight = (value, error) => {
    updatePropertyData("maxConstrHeight", value);
    setErrorMaxConstrHeight(error);
    setRegulationsError(errorMinBorder || error || errorBuildingDensity);
  };
  const setBuildingDensity = (value, error) => {
    updatePropertyData("buildingDensity", value);
    setErrorBuildingDensity(error);
    setRegulationsError(errorMinBorder || errorMaxConstrHeight || error);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        paddingLeft: "16px",
        pt: "6px",
        width: '100%'
      }}
    >
      <Typography sx={{ fontSize: "24px", mb: "24px" }}>{TEXT.siteSettings.regulationsTitle}</Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "16px",
        }}
      >
        <TextFieldNum
          label={"Min. Border Distance"}
          unit="m"
          placeholder="Enter value"
          requier={true}
          value={propertyData.minBorderDistance}
          setValue={setMinBorder}
          error={errorMinBorder}
          setError={setErrorMinBorder}
          stepSize={1}
          max={maxBorder}
          decimalPlaces={2}
          disabled={viewOnly}
        />
        <Box sx={{ display: "flex", mb: "16px" }}>
          <Box>
            <IconInformation fill="#5D5F6A" width="24px" height="24px" />
          </Box>

          <Typography sx={{ fontSize: "12px", color: "#777982", ml: "8px" }}>
          {TEXT.siteSettings.borderTooltip}
          </Typography>
        </Box>

        <TextFieldNum
          label={"Max. Construction Height"}
          unit="m"
          placeholder="Enter value"
          requier={true}
          value={propertyData.maxConstrHeight}
          setValue={setMaxConstrHeight}
          error={errorMaxConstrHeight}
          setError={setErrorMaxConstrHeight}
          stepSize={1}
          decimalPlaces={2}
          min={MIN_CONSTRUCTION_HEIGHT}
          max={100}
          disabled={viewOnly}
        />
        <Box sx={{ display: "flex", mb: "16px" }}>
          <Box>
            <IconInformation fill="#5D5F6A" width="24px" height="24px" />
          </Box>

          <Typography sx={{ fontSize: "12px", color: "#777982", ml: "8px" }}>
          {TEXT.siteSettings.heightTooltip}
          </Typography>
        </Box>

        {/* <TextFieldNum
          label={"Building Density"}
          unit="%"
          placeholder="Enter value"
          requier={true}
          value={propertyData.buildingDensity}
          setValue={setBuildingDensity}
          error={errorBuildingDensity}
          setError={setErrorBuildingDensity}
          stepSize={1}
          max={999}
        /> */}
      </Box>
    </Box>
  );
};
